module.exports = {
  name: 'Perplay Admin',
  desc: 'Perplay Admin - Perplay back office web',
  prefix: 'enlite',
  footerText: 'Perplay All Rights Reserved 2020',
  logoText: 'Perplay Admin',
};
